<ion-grid>
  <ion-row>
    <ion-col>

      <ion-card>
        <ion-card-header style="padding:0">
          <ion-toolbar color="primary">
            <ion-title>Digitális aláírás – időbélyeg (TSA)</ion-title>
          </ion-toolbar>
        </ion-card-header>
        <ion-card-content style="margin:15px;">
          <p style="text-align: justify;">
            Az aláírt PDF-ekre (bizonyítvány, számla stb.) RFC 3161 időbélyeg tehető egy időbélyeg-szolgáltató (TSA)
            címéről – ez igazolja, hogy az aláírás mikor keletkezett. Ingyenes, publikus szolgáltató pl. a DigiCert
            (<code>http://timestamp.digicert.com</code>). Ha a TSA épp nem elérhető, az aláírás időbélyeg nélkül készül el.
          </p>
          <ion-item lines="none">
            <ion-checkbox slot="start" [(ngModel)]="tsaEnabled"></ion-checkbox>
            <ion-label>Időbélyeg hozzáadása az aláíráshoz</ion-label>
          </ion-item>
          <ion-item>
            <ion-input label="TSA cím (URL)" label-placement="stacked" fill="outline"
              [(ngModel)]="tsaUrl" [disabled]="!tsaEnabled"
              placeholder="http://timestamp.digicert.com">
              <ion-icon slot="start" name="time-outline" aria-hidden="true"></ion-icon>
            </ion-input>
          </ion-item>
          <div style="margin-top:12px;">
            <ion-button color="success" [disabled]="tsaMentes" (click)="saveAlairasBeallitas()">
              <ion-icon slot="start" name="save-outline"></ion-icon>
              Mentés
            </ion-button>
          </div>
        </ion-card-content>
      </ion-card>

      <ion-card>
        <ion-card-header style="padding:0">
          <ion-toolbar color="primary">
            <ion-title>Bizonyítvány aláírója (igazgatói tanúsítvány)</ion-title>
          </ion-toolbar>
        </ion-card-header>
        <ion-card-content style="margin:15px;">
          <p style="text-align: justify;">
            A digitális bizonyítvány az Nkt. 57. § (6a) szerint „a köznevelési intézmény igazgatójának legalább fokozott
            biztonságú elektronikus aláírásával és időbélyegzővel ellátott elektronikus okirat”. Ha az igazgató személyes
            aláíró tanúsítványát feltöltöd és az alábbi táblában a <ion-icon name="person"></ion-icon> gombbal kijelölöd,
            a bizonyítványt az írja alá (az intézményi tanúsítvány helyett). Kijelölés nélkül az intézmény tanúsítványa ír
            alá, és a generálás figyelmeztet.
          </p>
          <p *ngIf="alairo?.igazgatoi" style="margin:4px 0;">
            <b>Kijelölt igazgatói tanúsítvány:</b> {{ alairo.igazgatoi.owner || alairo.igazgatoi.name }}
            <span *ngIf="alairo.igazgatoi.alany?.tipus === 'termeszetes'" style="color:#2b8a3e"> – természetes személy</span>
          </p>
          <ul *ngIf="alairo?.figyelmeztetes?.length" style="color:#b35c00; margin:4px 0; padding-left:18px;">
            <li *ngFor="let f of alairo.figyelmeztetes">{{ f }}</li>
          </ul>
        </ion-card-content>
      </ion-card>

      <ion-card>
        <ion-card-header style="padding:0">
          <ion-toolbar color="primary">
            <ion-title>P12 fájl feltöltése</ion-title>
          </ion-toolbar>
        </ion-card-header>
        <ion-card-content style="margin:15px;">

          <p style="text-align: justify;">A dokumentumok és elektronikus számlák szignálásához szüksége van a rendszernek a szervezet aláíró tanúsítványára. Ezt a fájlt itt tudja feltölteni és a program automatikusan elkezdi használni!</p>
          <ion-grid>
            <ion-row>
              <ion-col>
                Alapértelmezett tanúsítvány:
                <div class="container" style="padding: 0;">
                  <img src="assets/icon/certificate.png" width="120px"><br>
                  <table align="center">
                    <tr>
                      <td style="text-align: right; font-weight: bold;">Tulajdonos:&nbsp;</td>
                      <td style="text-align: left;">{{certused?.owner || "N/A"}}</td>
                    </tr>
                    <tr>
                      <td style="text-align: right; font-weight: bold;">Kiállító:&nbsp;</td>
                      <td style="text-align: left;">{{certused?.issuer || "N/A"}}</td>
                    </tr>
                    <tr>
                      <td style="text-align: right; font-weight: bold;">Lejárat:&nbsp;</td>
                      <td style="text-align: left;">{{certused?.validto || "N/A"}}</td>
                    </tr>
                  </table>
                </div>
              </ion-col>
              <ion-col>
                
              
          
          <ion-input style="display:none;" label="dummy" label-placement="stacked" fill="outline"
            placeholder=""><ion-icon slot="start" name="briefcase" aria-hidden="true"></ion-icon></ion-input><br>
          <ion-input label="Tanúsítvány jelszava" label-placement="stacked" fill="outline" type="password"
            [(ngModel)]="certPassword" placeholder="A .p12/.pfx jelszava">
            <ion-icon slot="start" name="key" aria-hidden="true"></ion-icon>
          </ion-input><br>
          <div class="container" appDnd (fileDropped)="onFileDropped($event)">
            <input type="file" accept=".p12,.pfx" #fileDropRef id="fileDropRef"
              (change)="fileBrowseHandler($event)" />
            <svg xmlns="http://www.w3.org/2000/svg" width="63" height="64" viewBox="0 0 63 64">
              <g fill="#3B454F" fill-rule="nonzero">
                <path
                  d="M42.656 15.135a1.953 1.953 0 0 1-1.391-.578L31.5 4.795l-9.765 9.762a1.97 1.97 0 1 1-2.785-2.785L30.106.616a1.97 1.97 0 0 1 2.785 0l11.157 11.156a1.97 1.97 0 0 1-1.392 3.363z" />
                <path
                  d="M31.5 36.791a1.97 1.97 0 0 1-1.969-1.969V2.01a1.97 1.97 0 0 1 3.938 0v32.812a1.97 1.97 0 0 1-1.969 1.969z" />
                <path
                  d="M55.781 63.041H7.22A7.225 7.225 0 0 1 0 55.822V41.385a4.599 4.599 0 0 1 4.594-4.594h7.234a4.567 4.567 0 0 1 4.402 3.276l2.814 9.382a.658.658 0 0 0 .628.467h23.656a.658.658 0 0 0 .628-.467l2.814-9.385a4.572 4.572 0 0 1 4.402-3.273h7.234A4.599 4.599 0 0 1 63 41.385v14.437a7.225 7.225 0 0 1-7.219 7.219zM4.594 40.729a.656.656 0 0 0-.657.656v14.437a3.286 3.286 0 0 0 3.282 3.282H55.78a3.286 3.286 0 0 0 3.282-3.282V41.385a.656.656 0 0 0-.657-.656h-7.234a.65.65 0 0 0-.628.467L47.73 50.58a4.628 4.628 0 0 1-4.402 3.274H19.672a4.567 4.567 0 0 1-4.402-3.276l-2.814-9.382a.65.65 0 0 0-.628-.467H4.594z" />
              </g>
            </svg>

            <h3>Húzza ide a fájlt (.p12)</h3>
            <h3 style="    margin-bottom: 15px !important;">vagy</h3>
            <label for="fileDropRef">Tallózás</label>
          </div>
          <div class="files-list">
            <div class="single-file" *ngFor="let file of files; let i = index">
              <div class="file-icon" style="width: 50px">
                <img *ngIf="file?.name.slice(-3) == 'p12'"
                  src="assets/icon/icons8-certificate-96.png">
              </div>
              <div class="info">
                <h4 class="name">
                  {{ file?.name }}
                </h4>
                <p class="size">
                  {{ formatBytes(file?.size) }}
                </p>
                <app-progress [progress]="file?.progress"></app-progress>
              </div>

              <div class="delete" (click)="deleteFile(i)">
                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="18" viewBox="0 0 14 18">
                  <path fill="#B1B1B1" fill-rule="nonzero"
                    d="M1 16c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2H3c-1.1 0-2 .9-2 2v10zm3.17-7.83a.996.996 0 0 1 1.41 0L7 9.59l1.42-1.42a.996.996 0 1 1 1.41 1.41L8.41 11l1.42 1.42a.996.996 0 1 1-1.41 1.41L7 12.41l-1.42 1.42a.996.996 0 1 1-1.41-1.41L5.59 11 4.17 9.58a.996.996 0 0 1 0-1.41zM10.5 1L9.79.29C9.61.11 9.35 0 9.09 0H4.91c-.26 0-.52.11-.7.29L3.5 1H1c-.55 0-1 .45-1 1s.45 1 1 1h12c.55 0 1-.45 1-1s-.45-1-1-1h-2.5z" />
                </svg>
              </div>
            </div>
          </div>

        </ion-col>
      </ion-row>
    </ion-grid>


          <ion-button style="background: white; border-radius: 5px" [strong]="true" expand="block" [disabled]="!cdis"
            (click)="uploadData()" shape="round" color="primary" id="open-loading"><ion-icon slot="start"
              name="cloud-upload"></ion-icon>Importálás</ion-button>
          <ion-loading trigger="open-loading1" message="Adatok feltöltése folyamatban, ne zárja be az ablakot!"
            spinner="crescent"></ion-loading>
        </ion-card-content>
      </ion-card>
    </ion-col>

  </ion-row>
  <ion-row>
<ion-col>

  <ngx-datatable
  class="ngx-datatable cronomitnew fixed-header fixed-row virtualized scroll-horz"
  [rows]="certdata" [sortType]="SortType.single" [columnMode]="ColumnMode.force" [limit]="10"
    [sorts]="[
{ prop: 'used', dir: 'desc' }
]" [messages]="{emptyMessage: 'Nincs megjeleníthető adat!'}">
  <ngx-datatable-column name="Név" prop="Típus">
    <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
      <b class="mobil">Név</b>
      {{ row.name }}
    </ng-template>
  </ngx-datatable-column>
  <ngx-datatable-column name="Tulajdonos" prop="owner">
    <ng-template let-value="value" ngx-datatable-cell-template>
      <b class="mobil">Tulajdonos</b>
      {{ value }}
    </ng-template>
  </ngx-datatable-column>
  <ngx-datatable-column name="Kiállító" prop="issuer">
    <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
      <b class="mobil">Kiállító</b>
      <span *ngIf="value">{{ value }}</span>
    </ng-template>
  </ngx-datatable-column>
  <ngx-datatable-column name="Lejárat" prop="validto">
    <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
      <b class="mobil">Lejárat</b>
      {{ value }}
    </ng-template>
  </ngx-datatable-column>
  <ngx-datatable-column name="Jelszó" prop="jelszo_beallitva">
    <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
      <b class="mobil">Jelszó</b>
      <span *ngIf="value">beállítva</span>
      <span *ngIf="!value" style="color:#c00">hiányzik</span>
    </ng-template>
  </ngx-datatable-column>
  <ngx-datatable-column name="Alapértelmezett" prop="used">
    <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
      <b class="mobil">Alapértelmezett (PDF)</b>
      <input type="checkbox" [checked]="value" disabled />
    </ng-template>
  </ngx-datatable-column>
  <ngx-datatable-column name="E-mail aláíró (S/MIME)" prop="smime">
    <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
      <b class="mobil">E-mail aláíró (S/MIME)</b>
      <input type="checkbox" [checked]="value" disabled />
    </ng-template>
  </ngx-datatable-column>
  <ngx-datatable-column name="Igazgatói (bizonyítvány)" prop="igazgatoi">
    <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
      <b class="mobil">Igazgatói (bizonyítvány)</b>
      <input type="checkbox" [checked]="value" disabled />
    </ng-template>
  </ngx-datatable-column>
  <ngx-datatable-column name="Műveletek">
    <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
      <b class="mobil">Műveletek</b>
      <ion-button color="success" size="small" style="margin-top:0" [disabled]="row.used" (click)="activate(row)" title="PDF-aláíró tanúsítvány">
        <ion-icon slot="icon-only" name="checkmark"></ion-icon>

      </ion-button>
      <ion-button color="tertiary" size="small" style="margin-top:0" [disabled]="row.smime" (click)="setSmime(row)" title="E-mail S/MIME aláíróvá tesz">
        <ion-icon slot="icon-only" name="mail"></ion-icon>

      </ion-button>
      <ion-button *ngIf="row.smime" color="medium" size="small" style="margin-top:0" (click)="clearSmime()" title="E-mail aláírás kikapcsolása">
        <ion-icon slot="icon-only" name="mail-unread"></ion-icon>

      </ion-button>
      <ion-button color="warning" size="small" style="margin-top:0" [disabled]="row.igazgatoi" (click)="setIgazgatoi(row)" title="Igazgatói (személyes) aláíró a bizonyítványhoz">
        <ion-icon slot="icon-only" name="person"></ion-icon>

      </ion-button>
      <ion-button *ngIf="row.igazgatoi" color="medium" size="small" style="margin-top:0" (click)="clearIgazgatoi()" title="Igazgatói jelölés megszüntetése">
        <ion-icon slot="icon-only" name="person-remove"></ion-icon>

      </ion-button>
      <ion-button color="primary" size="small" style="margin-top:0" (click)="letolt(row)" title="Tanúsítványfájl letöltése (.p12/.pfx)">
        <ion-icon slot="icon-only" name="download"></ion-icon>

      </ion-button>
      <ion-button color="danger" size="small" style="margin-top:0" (click)="remove(row)">
        <ion-icon slot="icon-only" name="trash"></ion-icon>

      </ion-button>
    </ng-template>
  </ngx-datatable-column>
</ngx-datatable>

</ion-col>



  </ion-row>
</ion-grid>


